var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.5L4 19V15H3C2.45 15 1.979 14.8043 1.587 14.413C1.19567 14.021 1 13.55 1 13V5.5H0V3.5H4V2H2.5V0H7.5V2H6V3.5H10V5.5H9V13C9 13.55 8.80433 14.021 8.413 14.413C8.021 14.8043 7.55 15 7 15H6V20.5ZM15 20C13.9 20 12.9583 19.6083 12.175 18.825C11.3917 18.0417 11 17.1 11 16V8C11 6.9 11.3917 5.95833 12.175 5.175C12.9583 4.39167 13.9 4 15 4C16.1 4 17.0417 4.39167 17.825 5.175C18.6083 5.95833 19 6.9 19 8V16C19 17.1 18.6083 18.0417 17.825 18.825C17.0417 19.6083 16.1 20 15 20ZM3 13H7V11.5H4.5V10H7V8.5H4.5V7H7V5.5H3V13ZM13 14H17V10H13V14Z",
    fill: "#113E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon3);
export default __webpack_public_path__ + "static/media/aboutIcon3.c930b84d74b9a884a5a650d93e3ab589.svg";
export { ForwardRef as ReactComponent };